import { atom } from 'jotai';
import { FilterViewEnum } from 'types/FilterProjects';

export const selectedLeadsFilterAtom = atom<FilterViewEnum[]>([FilterViewEnum.ALL]);
